import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles'

const HeroLiveTicker = ({
  programmeHead,
}) => {
  function importAllImages(image) {
    const imageList = {}
    image?.keys().forEach((item) => { imageList[item.replace('./', '')] = image(item) })
    return imageList
  }
  const imageList = importAllImages(require.context('./images', false, /\.(png|jpe?g|svg)$/))

  return (
    <div className={`hero-cta-wrapper-indicator ${programmeHead ? 'programme' : 'home'}`}>
      <div className="indicator-container">
        <div className="indicator-title">
          Stream <span>LIVE</span> on your favourite devices
          <div className="device-container">
            <div className="device-scroll">
              { Object.entries(imageList).map(
                ([key, value]) => <img key={key} src={value} alt={key} />
              )}
            </div>
            <div className="device-scroll device-sub-scroll">
              { Object.entries(imageList).map(
                ([key, value]) => <img key={key} src={value} alt={key} />
              )}
            </div>
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}

HeroLiveTicker.propTypes = {
  programmeHead: PropTypes.bool,
}

HeroLiveTicker.defaultProps = {
  programmeHead: false,
}

export default HeroLiveTicker
